export default __webpack_public_path__ + "static/media/six_sec_dash_thumb.b975b5fa.png";